import * as React from "react";
const SvgWarehouse20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m10 .906 10 4.445V19H0V5.35L10 .906ZM2 6.65V17h2v-7h12v7h2V6.65l-8-3.555L2 6.65Zm12 8.85V17H6v-1.5h8Zm0-2V12H6v1.5h8Zm-4-5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
      clipRule: "evenodd"
    })
  );
export default SvgWarehouse20Px;
